(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE = {
  id: "53bc65f7fe2adcf7b428ad1e716b48dfbc4520de"
};